import ScrollWaypoint from '@costar/scroll-waypoint'
import type { FC } from 'react'
import React, { useCallback } from 'react'

import { useTabsContext } from './tabs-context'
import type { TabPanelProps } from './types'
import { TAB_THEME_KEY } from './types'
import { noop } from '../../utils'
import { BoxPrivate } from '../_primitives/box/box'

const TabPanel: FC<TabPanelProps> = props => {
  const {
    variant = 'panel',
    children,
    value,
    scrollOffset,
    threshold,
    ...other
  } = props
  const {
    variant: tabVariant,
    selection,
    mode,
    selectionChangedObserver
  } = useTabsContext()
  const onEnterHandler = useCallback(() => {
    if (value !== undefined) {
      selectionChangedObserver?.notify({ value, source: 'panels' })
    }
  }, [selectionChangedObserver, value])

  const content = (
    <BoxPrivate
      role="tabpanel"
      variant={tabVariant ? `${tabVariant}.${variant}` : variant}
      __themeKey={TAB_THEME_KEY}
      hidden={mode == 'switch' && selection !== value}
      id={`nav-tabpanel-${value}`}
      aria-labelledby={`nav-tab-${value}`}
      {...other}
    >
      {mode === 'switch' ? (selection === value ? children : null) : children}
    </BoxPrivate>
  )

  return mode === 'stack' ? (
    <ScrollWaypoint
      enabled
      eventKey={`${value}`}
      onEnter={onEnterHandler}
      onLeave={noop}
      threshold={threshold}
    >
      <BoxPrivate
        as="span"
        id={`nav-scrollto-${value}`}
        height={'0px'}
        position={'relative'}
        top={`${scrollOffset}`}
      ></BoxPrivate>
      {content}
    </ScrollWaypoint>
  ) : (
    content
  )
}

export default TabPanel
